<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('coinsflip.user_report') }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('coinsflip.user_report_list') }} </v-card-title>

        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>
            <span class="mr-2">
              <v-text-field
                v-model="dateFrom"
                :label="$t('coinsflip.date_from')"
                placeholder="DD/MM/YYYY HH:mm:ss"
                outlined
                dense
                hide-details
                style="width: 200px"
              />
            </span>
            <span class="mr-2">
              <v-text-field
                v-model="dateTo"
                :label="$t('coinsflip.date_to')"
                placeholder="DD/MM/YYYY HH:mm:ss"
                outlined
                dense
                hide-details
                style="width: 200px"
              />
            </span>
            <!-- <span class="mr-2">
              <select-input
                v-model="status"
                :items="statusOptions"
                :label="$t('coinsflip.status')"
                style="width: 150px"
              />
            </span> -->
            <v-btn color="primary" @click="searchReport" class="mr-2"> {{ $t('search') }} </v-btn>
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-4 d-flex flex-column">
          <v-data-table
            mobile-breakpoint="0"
            style="width: 100%"
            :headers="headers"
            :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')"
            :loading="loading"
            :items="reportData"
            :items-per-page="pagination.rowsPerPage"
            :page="pagination.currentPage"
            @page-count="pagination.pageCount = $event"
            :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }"
            :options.sync="pagination"
            :server-items-length="pagination.totalItems"
          >
            <template v-slot:[`item.username`]="{ item }">
              {{ item.username || '-' }}
            </template>
            <template v-slot:[`item.total_bet_amount`]="{ item }">
              {{ formatCurrency(item.total_bet_amount) }}
            </template>
            <template v-slot:[`item.total_win_loss_amount`]="{ item }">
              <span :class="item.total_win_loss_amount >= 0 ? 'success--text' : 'error--text'">
                {{ formatCurrency(item.total_win_loss_amount) }}
              </span>
            </template>
            <template v-slot:[`item.total_web_profit`]="{ item }">
              {{ formatCurrency(item.total_web_profit) }}
            </template>
            <template v-slot:[`item.total_company_profit`]="{ item }">
              {{ formatCurrency(item.total_company_profit) }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ formatDateTime(item.created_at) }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn color="info" small @click="viewUserDetail(item.user_id, item.username)" class="">
                {{ $t('coinsflip.view_detail') }}
              </v-btn>
            </template>

            <template v-if="summaryData" slot="body.append">
              <tr>
                <th class="text-center text-no-wrap">{{ $t('coinsflip.summary') }}</th>
                <th>{{ $t('coinsflip.total_players') }}</th>
                <th class="text-center">{{ $t('coinsflip.total_bet_count') }}</th>
                <th class="text-right">{{ $t('coinsflip.total_bet_amount') }}</th>
                <th class="text-right">{{ $t('coinsflip.total_win_loss_amount') }}</th>
                <th class="text-right">{{ $t('coinsflip.total_web_profit') }}</th>
                <th class="text-right">{{ $t('coinsflip.total_company_profit') }}</th>
                <th></th>
              </tr>
              <tr>
                <th></th>
                <th class="text-center">{{ summaryData.total_players }}</th>
                <th class="text-center">{{ summaryData.total_bet_count }}</th>
                <th class="text-right">{{ summaryData.total_bet_amount | currency }}</th>
                <th class="text-right">{{ summaryData.total_win_loss_amount | currency }}</th>
                <th class="text-right">{{ summaryData.total_web_profit | currency }}</th>
                <th class="text-right">{{ summaryData.total_company_profit | currency }}</th>
                <th></th>
              </tr>
            </template>
          </v-data-table>

          <div class="text-center pt-2">
            <v-pagination
              v-model="pagination.currentPage"
              :length="pagination.pageCount"
              :total-visible="7"
              @input="loadReport"
            ></v-pagination>
          </div>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import SelectInput from '@/components/input/SelectInput.vue'
import store from '@/store'

export default {
  components: {
    SelectInput,
  },

  data() {
    return {
      dateFrom: moment().startOf('day').subtract(3, 'days').format('DD/MM/YYYY HH:mm:ss'),
      dateTo: moment().endOf('day').format('DD/MM/YYYY HH:mm:ss'),
      status: 'all',
      statusOptions: [
        { text: this.$t('coinsflip.status_all'), value: 'all' },
        { text: this.$t('coinsflip.status_success'), value: 'success' },
        { text: this.$t('coinsflip.status_failed'), value: 'failed' },
        { text: this.$t('coinsflip.status_wait'), value: 'wait' },
      ],
      headers: [
        {
          text: this.$t('coinsflip.order_number'),
          value: 'order_number',
          width: '80px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.username'),
          value: 'username',
          width: '150px',
          align: 'left',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.total_bet_count'),
          value: 'total_bet_count',
          width: '120px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.total_bet_amount'),
          value: 'total_bet_amount',
          width: '120px',
          align: 'right',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.total_win_loss_amount'),
          value: 'total_win_loss_amount',
          width: '120px',
          align: 'right',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.total_web_profit'),
          value: 'total_web_profit',
          width: '120px',
          align: 'right',
          sortable: false,
        },
        {
          text: this.$t('coinsflip.total_company_profit'),
          value: 'total_company_profit',
          width: '120px',
          align: 'right',
          sortable: false,
        },
        // {
        //   text: this.$t('coinsflip.created_at'),
        //   value: 'created_at',
        //   width: '150px',
        //   align: 'center',
        //   sortable: false,
        // },
        {
          text: '',
          value: 'action',
          width: '120px',
          align: 'center',
          sortable: false,
        },
      ],
      reportData: [],
      loading: false,
      pagination: {
        currentPage: 1,
        rowsPerPage: 25,
        totalItems: 0,
        pageCount: 0,
      },
      summaryData: null,
    }
  },
  computed: {
    summaryTableData() {
      if (!this.summaryData) return []
      return [this.summaryData]
    },
  },
  async created() {
    // Check for query parameters from navigation
    if (this.$route.query.date_from) {
      this.dateFrom = this.$route.query.date_from
    }
    if (this.$route.query.date_to) {
      this.dateTo = this.$route.query.date_to
    }
    if (this.$route.query.status) {
      this.status = this.$route.query.status
    }

    this.addLogPage()
    await this.loadReport()
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(
          res =>
            (data = {
              ip: res.data.ip,
              name: 'รายงานผู้เล่นหัวก้อย',
              url: window.location.href,
              detail: 'รายงานผู้เล่นหัวก้อย',
              admin: userSystem.name ? userSystem.name : '',
            }),
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // Error handling
      }
    },
    async searchReport() {
      this.pagination.currentPage = 1
      await this.loadReport()
    },
    async loadReport() {
      this.loading = true
      this.reportData = []

      try {
        const params = {}
        if (this.dateFrom) params.date_from = this.dateFrom
        if (this.dateTo) params.date_to = this.dateTo
        if (this.status && this.status !== 'all') params.status = this.status
        params.page = this.pagination.currentPage
        params.rows = this.pagination.rowsPerPage

        const rs = await this.$store.dispatch('getUserReport', params)

        if (rs && rs.data) {
          this.reportData = rs.data.map(item => ({
            order_number: item.order_number || 0,
            user_id: item.user_id,
            username: item.username,
            total_bet_amount: item.total_bet_amount || 0,
            total_bet_count: item.total_bet_count || 0,
            total_win_loss_amount: item.total_win_loss_amount || 0,
            total_bet_win_amount: item.total_bet_win_amount || 0,
            total_bet_lose_amount: item.total_bet_lose_amount || 0,
            total_web_profit: item.total_web_profit || 0,
            total_company_profit: item.total_company_profit || 0,
            created_at: item.created_at,
          }))
          this.pagination.pageCount = rs.total_pages || 0
          this.pagination.totalItems = rs.total || 0
          this.summaryData = rs.summary || null
        }
      } catch (err) {
        this.$swal.fire({
          icon: 'error',
          title: err.message || this.$t('error_occurred'),
        })
      } finally {
        this.loading = false
      }
    },
    formatCurrency(value) {
      return parseFloat(value || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    formatDateTime(date) {
      if (!date) return '-'
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    viewUserDetail(userId, username) {
      const params = { user_id: userId, username: username }
      if (this.dateFrom) params.date_from = this.dateFrom
      if (this.dateTo) params.date_to = this.dateTo
      if (this.status && this.status !== 'all') params.status = this.status

      this.$router.push({
        name: 'coinsflipuserdetail',
        query: params,
      })
    },
  },
}
</script>

<style scoped>
.border-top {
  border-top: 2px solid #e0e0e0;
}
</style>
